<template>
  <div class="scale-with-screen">
    <div class="book-summary">
      <div class="bpg-title">
        <span>Summary</span>
      </div>
      <div>
      <div class="book-summary-text" v-html="summaryText" />
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'BookSummary',
  props: {
    summaryText: {
      type: String,
      required: true,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './scss/variables';

  .book-summary {
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: left;
    margin-top: 3em;
    background-color: $even-lighter-green;
    padding:3em;
    padding-top:0;
    .bpg-title {
      text-align:left;
    }
    .bpg-title:after {
      width:100%;
    }
    .book-summary-text {
      text-align:left;
      font-size: $font-medium;
      padding-top:1em;
    }
  }
  @media only screen and (max-width: 750px) {
    .book-summary {
      font-size: 220%;
    }
  }
</style>
